// extracted by mini-css-extract-plugin
module.exports = {"day_use_footer_wrapper":"DayUseMobileNav_day_use_footer_wrapper__QWRRT"};